module.exports = __webpack_public_path__ + "img/2.05.thmb.90c174d9.jpg";